<template>
  <about></about>
</template>
<script>
import about from '@aboutH5/about.vue';

export default {
  name: "about-h5",
  components: {
    about
  }
}
</script>